import axios from "axios";
import mock from "./mock";
// 创建axios实例
const instance = axios.create({
  // baseURL: "http://47.117.168.187:8899",
  baseURL: "http://manage.shbaishan.com",
  timeout: 5000,
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
  },
});
// 请求拦截器
instance.interceptors.request.use(
  (config: any) => {
    const language = sessionStorage.getItem("lang") || "ch";
    config.params = { ...config.params, way: language };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // 处理响应数据
    return response.data;
  },
  (error) => {
    // 处理响应错误
    // if (mock[error.config.url]) {
    //   return Promise.resolve(mock[error.config.url]);
    // }
    return Promise.reject(error);
  }
);

export default instance;
